// Two feature-area splits (Design's canvas/sketchbook/preview panels;
// Chats' direct-messages/AI-builder split) live in component `useState`,
// not localStorage or the URL — so resolveFeatureArea() can't see them from
// a standalone function. The owning components call setFeatureAreaOverride()
// whenever their internal mode changes (one extra line at the same call
// sites where they already write their view-mode state), and
// resolveFeatureArea() checks this first before falling back to its
// route-only logic. Plain module-level state, same lightweight pattern as
// navigationHistory.ts — nothing needs to re-render off it.

import type { FeatureArea } from "../lib/feedbackFeatureAreas";

let currentOverride: FeatureArea | null = null;

export const setFeatureAreaOverride = (area: FeatureArea | null) => {
  currentOverride = area;
};

export const getFeatureAreaOverride = (): FeatureArea | null => currentOverride;
